var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3480",
    "data-name": "Group 3480",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.863,
    height: 23.862,
    viewBox: "0 0 23.863 23.862",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_645",
    "data-name": "Rectangle 645",
    width: 23.863,
    height: 23.862,
    fill: "#6b6b6b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9714",
    "data-name": "Group 9714",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M23.863,5.358V18.545q-.07.3-.139.6a5.9,5.9,0,0,1-1.589,2.908,7.6,7.6,0,0,1-1.238.962,5.031,5.031,0,0,1-2.7.833c-4.045.025-8.09,0-12.135.015a6.078,6.078,0,0,1-2.9-.706,6,6,0,0,1-1.868-1.57,5.5,5.5,0,0,1-.98-1.8,5.266,5.266,0,0,1-.291-1.528C0,14.287.013,10.32,0,6.352A6.82,6.82,0,0,1,.409,3.8,5.919,5.919,0,0,1,1.77,1.724,7.043,7.043,0,0,1,2.923.844,4.335,4.335,0,0,1,4.39.229C4.716.161,5.04.077,5.364,0H18.458a.256.256,0,0,0,.07.042c.357.079.721.136,1.072.237a5.71,5.71,0,0,1,2.785,1.8,5.712,5.712,0,0,1,1.3,2.528c.055.251.121.5.182.749M11.874,1.992c-1.918,0-3.836-.005-5.754,0A5.831,5.831,0,0,0,5.075,2.1,3.663,3.663,0,0,0,2.89,3.441a3.946,3.946,0,0,0-.9,2.6C2.009,9.934,2,13.824,2,17.715a6.575,6.575,0,0,0,.057.872,3.723,3.723,0,0,0,1.4,2.4,3.947,3.947,0,0,0,2.631.888c3.875-.02,7.75-.005,11.625-.013a4.772,4.772,0,0,0,1.067-.108,3.869,3.869,0,0,0,2.474-1.774,4.149,4.149,0,0,0,.609-2.271q0-5.568,0-11.136a7.871,7.871,0,0,0-.108-1.442A3.746,3.746,0,0,0,20.083,2.66a4.258,4.258,0,0,0-2.455-.67c-1.918,0-3.836,0-5.754,0",
    transform: "translate(0)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M82.054,88.273A5.87,5.87,0,0,1,83.833,84a5.688,5.688,0,0,1,4.1-1.7A5.85,5.85,0,0,1,92.194,84a5.79,5.79,0,0,1,1.785,4.237,5.715,5.715,0,0,1-1.548,4.011A5.894,5.894,0,0,1,88.3,94.209a5.713,5.713,0,0,1-4.4-1.645,5.814,5.814,0,0,1-1.847-4.291m5.937-3.985a3.973,3.973,0,1,0,3.99,3.774,3.92,3.92,0,0,0-3.99-3.774",
    transform: "translate(-76.095 -76.32)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M233.918,57.933a1.476,1.476,0,0,1-1.494-1.492,1.53,1.53,0,0,1,1.354-1.453,1.479,1.479,0,0,1,1.62,1.325,1.45,1.45,0,0,1-1.48,1.619",
    transform: "translate(-215.544 -50.99)",
    fill: "#6b6b6b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.9116afd1a02234fc435842ed75e660a0.svg";
export { ForwardRef as ReactComponent };